import { captureException, init as sentryInit } from '@sentry/react'
import React from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './app.tsx'
import './index.css'

import { APP_NAME } from '@langmail/shared-ui'

import { followSystemColorScheme } from './lib/color-scheme'
import { reactHealthCheck } from './utils/react-health-check'

followSystemColorScheme()

// Error tracking via Better Stack (Sentry-SDK compatible). The DSN is baked in
// at build time and only present for production builds; skip init when absent.
if (import.meta.env.VITE_BETTERSTACK_ERRORS_DSN) {
  sentryInit({
    dsn: import.meta.env.VITE_BETTERSTACK_ERRORS_DSN,
    environment: import.meta.env.MODE,
    // Don't send default PII (IP, request headers, etc.) to the error-tracking
    // vendor — matches the backend (@langmail/logger uses sendDefaultPii: false)
    // and our privacy posture.
    sendDefaultPii: false,
  })
}

// Set title based on environment
if (import.meta.env.DEV) {
  document.title = `DEV: ${APP_NAME}`
} else {
  document.title = APP_NAME
}

// Check React version in development
reactHealthCheck()

createRoot(document.getElementById('root')!, {
  onUncaughtError: (error, errorInfo) => {
    captureException(error, { contexts: { react: { componentStack: errorInfo.componentStack } } })
  },
  onCaughtError: (error, errorInfo) => {
    captureException(error, { contexts: { react: { componentStack: errorInfo.componentStack } } })
  },
  onRecoverableError: (error, errorInfo) => {
    captureException(error, { contexts: { react: { componentStack: errorInfo.componentStack } } })
  },
}).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
